import { routerReducer } from '@ngrx/router-store';
import { ActionReducer, MetaReducer, StoreModule } from '@ngrx/store';
import { AppState } from './app.state';

export * from './app.effects';
export * from './app.state';
export * from './app.selectors';

// console.log all actions
export function debug(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state, action) {
    // console.log('state', state);
    // console.log('action', action);

    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<any>[] = [debug];

export const ApplicationStoreModule = StoreModule.forRoot<AppState>(
  {
    router: routerReducer,
  },
  {
    metaReducers: metaReducers,
  }
);
